import {
  Box,
  Button,
  CircularProgress,
  Grid,
  InputLabel,
  makeStyles,
  TextField,
  Typography
} from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import { Formik } from 'formik';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import CustomDialog from 'src/app/components/CustomDialog';
import { STATUS_API } from 'src/app/constant/config';
import { updateDriverAccountPassword } from 'src/features/driverSlice';

const UpdatePasswordModal = ({ open, onClose, driverSelected, onSuccess }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const statusUpdatePassword = useSelector(
    state => state.driverSlice.statusUpdatePassword
  );

  const handleSubmit = async values => {
    if (!driverSelected?.user?.id) return;

    const resultAction = await dispatch(
      updateDriverAccountPassword({
        id: driverSelected.user.id,
        body: {
          password: values.password.trim()
        }
      })
    );

    if (updateDriverAccountPassword.fulfilled.match(resultAction)) {
      onClose();
      if (onSuccess) onSuccess();
    }
  };

  return (
    <CustomDialog
      title={`Cập nhật mật khẩu`}
      open={open}
      onClose={onClose}
      sizeSmall={true}
    >
      <Formik
        initialValues={{ password: '' }}
        enableReinitialize={true}
        validationSchema={Yup.object().shape({
          password: Yup.string()
            .min(6, 'Mật khẩu phải có ít nhất 6 ký tự')
            .max(100)
            .matches(/^\S+$/, 'Mật khẩu không được chứa khoảng trắng')
            .required('Vui lòng nhập mật khẩu mới')
        })}
        onSubmit={handleSubmit}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          touched,
          values
        }) => (
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item md={12} xs={12}>
                <InputLabel style={{ marginBottom: '21px' }}>
                  Mật khẩu mới<span style={{ color: 'red' }}> *</span>
                </InputLabel>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  name="password"
                  type="password"
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  helperText={touched.password && errors.password}
                  error={Boolean(touched.password && errors.password)}
                  InputProps={{
                    style: {
                      fontSize: '16px',
                      padding: '0 8px',
                      height: '35px'
                    }
                  }}
                />
              </Grid>
            </Grid>
            <Box my={3}>
              <Box className={classes.groupButtonSubmit}>
                <Button
                  style={{
                    marginRight: '10px',
                    textTranform: 'none !important'
                  }}
                  onClick={onClose}
                  className="btn-main btn-plain mx-3"
                  color="primary"
                  size="large"
                  variant="contained"
                >
                  Thoát
                </Button>
                <Button
                  style={{
                    marginRight: '10px',
                    textTranform: 'none !important'
                  }}
                  className="btn-main mx-3"
                  color="primary"
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  Lưu lại 
                </Button>
                {statusUpdatePassword === STATUS_API.PENDING && (
                  <CircularProgress
                    size={24}
                    className={classes.buttonProgress}
                  />
                )}
              </Box>
            </Box>
          </form>
        )}
      </Formik>
    </CustomDialog>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  groupButtonSubmit: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '15px',
    '& .left-button': {
      display: 'flex'
    }
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  }
}));

export default React.memo(UpdatePasswordModal);
